import { useEffect, useState } from "react";
import BookingDataService from "../../services/Booking";
import ExpertDataService from "../../services/Expert";
import { useNavigate, useParams } from "react-router-dom";
import { BookingDetails } from "../../Config/Booking";
import { getDurationForSessionType } from "../../Config/Expert";
import Select from "react-select";

export const EditBooking = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("logged_in_user_token");
  const [expertList, setExpertList] = useState<any>([]);
  const [is_booking_modified, setIsBookingModified] = useState<any>(false);
  const [sessionDate, setSessionDate] = useState("");
  const [sessionTime, setSessionTime] = useState("");
  const [expertInformation, setExpertInformation] = useState({
    uuid: "",
    full_name: "",
    role: "",
  });

  const options = expertList.map((el: any) => ({
    value: el._id,
    label: el.data.full_name,
  }));

  const fetchExperts = async () => {
    try {
      const expertRes = await ExpertDataService.getExperts(token);
      setExpertList(expertRes.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleExpertChange = (value: any) => {
    const data = expertList.find((el: any) => el._id === value);
    if (data) {
      setExpertInformation({
        ...expertInformation,
        uuid: value,
        full_name: data.data.full_name,
        role: data.data.role,
      });

      setBookingDetails((prev: any) => ({
        ...prev,
        is_booking_modified: true,
      }));
    }
  };

  const handleBookingTypeChange = (value: string) => {
    setBookingDetails((prev: any) => ({
      ...prev,
      booking_type: value,
      session_duration: getDurationForSessionType(prev.session_type, value),
      is_booking_modified: true,
    }));
  };

  const [bookingDetails, setBookingDetails] = useState<any>(BookingDetails);
  const [initialBookingDetails, setInitialBookingDetails] =
    useState<any>(BookingDetails);

  const formattedTime = (inputTime: string) => {
    const parts = inputTime.split(":");

    if (parts.length === 2) {
      let hour = parseInt(parts[0], 10);
      const minute = parts[1];
      let meridiem = "AM";

      if (hour >= 12) {
        meridiem = "PM";
        if (hour > 12) {
          hour -= 12;
        }
      }

      if (hour === 0) {
        hour = 12;
      }

      const formattedTime = `${hour}:${minute} ${meridiem}`;

      return formattedTime;
    }
    return "";
  };
  const formattedDate = (inputDate: string) => {
    const parts = inputDate.split("-");

    if (parts.length === 3) {
      const formattedDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
      return formattedDate;
    }
    return "";
  };

  const handleSessionDateChange = (e: any) => {
    setSessionDate(e.target.value);
  };
  const handleSessionTimeChange = (e: any) => {
    setSessionTime(e.target.value);
  };
  const handleChange = (e: any) => {
    let value = e.target.value;
    setBookingDetails({
      ...bookingDetails,
      [e.target.name]: value,
    });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    const isSessionDateChanged =
      sessionDate !== convertDateFormat(initialBookingDetails.session_date);

    const isSessionTimeChanged =
      sessionTime !== convertTo24HourFormat(initialBookingDetails.session_time);

    const isExpertChanged =
      expertInformation.uuid !== initialBookingDetails.expert_information.uuid;

    const isReschedule =
      isSessionDateChanged || isSessionTimeChanged || isExpertChanged;

    const data = {
      ...bookingDetails,
      is_booking_modified,
      session_duration: getDurationForSessionType(
        bookingDetails.session_type,
        bookingDetails.booking_type
      ),
      session_date: formattedDate(sessionDate),
      // Unambiguous ISO day so the backend never has to guess MM/dd vs dd/MM.
      session_date_iso: sessionDate,
      session_time: formattedTime(sessionTime),
      expert_information: expertInformation,
    };

    if (isReschedule) {
      BookingDataService.rescheduleBooking(data, id)
        .then((response: any) => {
          navigate(`/bookings/view/${id}`);
        })
        .catch((e: Error) => {
          console.log(e);
        });
    } else {
      BookingDataService.updateBooking(data, id)
        .then((response: any) => {
          navigate(`/bookings/view/${id}`);
        })
        .catch((e: Error) => {
          console.log(e);
        });
    }
  };

  const convertDateFormat = (inputDate: any) => {
    if (inputDate) {
      const parts = inputDate.split("/");

      const month = parts[0].padStart(2, "0");
      const day = parts[1].padStart(2, "0");
      const year = parts[2];
      const newDateFormat = `${year}-${month}-${day}`;
      return newDateFormat;
    }
    return "";
  };
  const convertTo24HourFormat = (timeString: string) => {
    if (timeString) {
      const [time, period] = timeString.split(" ");
      const [hours, minutes] = time.split(":");

      let newHours = parseInt(hours, 10);
      if (period === "PM" && newHours !== 12) {
        newHours += 12;
      } else if (period === "AM" && newHours === 12) {
        newHours = 0;
      }

      const newTime = `${newHours.toString().padStart(2, "0")}:${minutes}`;
      return newTime;
    }
    return "";
  };
  const fetchData = () => {
    BookingDataService.getSingleBooking(id)
      .then((response: any) => {
        const data = response.data;
        setBookingDetails({
          ...data,
        });
        setInitialBookingDetails({
          ...data,
        });
        setSessionDate(convertDateFormat(data.session_date));
        setSessionTime(convertTo24HourFormat(data.session_time));
        setExpertInformation({ ...data.expert_information });
        setIsBookingModified(data.is_booking_modified);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  useEffect(() => {
    fetchData();
    fetchExperts();
  }, []);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Bookings - Quick View</div>
      <div className="p-5">
        <div className="row m-0 justify-content-center">
          <div className="card p-5 col-lg-10">
            <h3>Basic Info</h3>
            <form
              className="add_assesment_form"
              onSubmit={(e: any) => handleSubmit(e)}
            >
              <div className="form-row mt-3">
                <div className="form-group ml-1 mb-4 edit-icon">
                  <label className="form-label" htmlFor="booking_date">
                    Is Booking Modified
                  </label>
                  <input
                    className="ml-4"
                    type="checkbox"
                    aria-label="Checkbox"
                    // value={is_booking_modified}
                    checked={is_booking_modified}
                    onChange={(e) => setIsBookingModified(e.target.checked)}
                    id="is_booking_modified"
                    name="is_booking_modified"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Session Date
                  </label>
                  <input
                    value={sessionDate}
                    onChange={handleSessionDateChange}
                    type="date"
                    className="form-control"
                    id="session_date"
                    name="session_date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Session Time
                  </label>
                  <input
                    value={sessionTime}
                    onChange={handleSessionTimeChange}
                    type="time"
                    className="form-control"
                    id="session_time"
                    name="session_time"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Select Expert:
                  </label>
                  <Select
                    id="expert"
                    name="expert"
                    options={options}
                    placeholder="Choose Expert"
                    isClearable
                    value={options.find(
                      (option: any) => option.value === expertInformation.uuid
                    )}
                    onChange={(option: any) =>
                      handleExpertChange(option ? option.value : null)
                    }
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Booking Type
                  </label>
                  <select
                    value={bookingDetails.booking_type}
                    name="booking_type"
                    onChange={(e) => handleBookingTypeChange(e.target.value)}
                    className="form-control"
                    id="booking_type"
                  >
                    <option value="">Select Session Type</option>
                    <option value="couple">Couple</option>
                    <option value="inperson">Inperson</option>
                    <option value="video">Video</option>
                    <option value="call">Call</option>
                    <option value="chat">Chat</option>
                  </select>
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Booking Status
                  </label>
                  <select
                    value={bookingDetails.booking_status}
                    name="booking_status"
                    onChange={handleChange}
                    className="form-control"
                    id="booking_status"
                  >
                    <option value="">Select </option>
                    <option value="BOOKED">Booked</option>
                    <option value="RESCHEDULED">Resheduled</option>
                    <option value="CANCELLED">Canceled</option>
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Post Session Status
                  </label>
                  <select
                    value={bookingDetails.post_session_status}
                    name="post_session_status"
                    onChange={handleChange}
                    className="form-control"
                    id="post_session_status"
                  >
                    <option value="">Select </option>
                    <option value="NO_SHOW">No Show</option>
                    <option value="SUCCESSFUL">Successful</option>
                    <option value="RESCHEDULED">Rescheduled</option>
                    <option value="PARTIAL_SESSION">Partial Session</option>
                    <option value="EXPERT_LEVEL_ISSUE">
                      Expert Level Issue
                    </option>
                    <option value="USER_LEVEL_ISSUE">User Level Issue</option>
                  </select>
                </div>
              </div>
              <button
                type="submit"
                className="btn action-btn mt-3 px-5 submit-button"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
